import axios from "axios";
import * as types from '../constants/ActionTypes';
import { toast } from 'react-toastify';

// Url's
const getResetPswdUrl = `${process.env.REACT_APP_API_URL}mobileshop/reset-consumer-password`;

// Actions
const resetPasswordRequested = () => ({
    type: types.RESET_PASSWORD_REQUEST
  });

const resetPasswordSuccess = data => ({
    type: types.RESET_PASSWORD_SUCCESS,
    data
  });
    
const resetPasswordFailure = error => ({
    type: types.RESET_PASSWORD_FAILURE,
    error
  });

// API
export const resetPassword = (options) => {
    return dispatch => {
      dispatch(resetPasswordRequested());
      // 
      axios.post(getResetPswdUrl, options, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            //'Content-Type': 'application/json; charset=UTF-8'
          },
      })
        .then(res => {
          if (res.data.ack === "Success") {
            dispatch(resetPasswordSuccess(res.data.results));
            toast.success(`Success! Password details sent to your mail. Please check.`);
          } else if (res.data.ack === "Failure") {
            toast.error(`${res.data.status.message}`);
            dispatch(resetPasswordFailure(res.data.status));
          } 
        })
        .catch(err => {
            throw err;
          // dispatch(addTodoFailure(err.message));
        });
    };
  };